import React, { Component } from "react";
import { connect } from "react-redux";
import { updateWord } from "../../store/actions/wordAction";
import { Redirect } from "react-router-dom";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";

import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Container from "@material-ui/core/Container";
import "./EditExistingWordDialog.css";
import NewWordScrapperAll from "../scrape/NewWordScrapperAll";
import GoogleTranslateAPI from "../shared/GoogleTranslateAPI";
import DialogScrapResult from "../scrape/DialogScrapResult";

import NewWordScrapper from "../scrape/NewWordScrapper";
import IconCancel from "@material-ui/icons/Cancel";
import IconArrow from "@material-ui/icons/ExpandMore";
import IconDeleteAll from "@material-ui/icons/PriorityHigh";
import IconToRight from "@material-ui/icons/LastPage";
import { createWord } from "../../store/actions/wordAction";

import IconButton from "@material-ui/core/IconButton";

import Menu from "@material-ui/core/Menu";
var Scrap_Button_Clicked;

export class EditExistingWordDialog extends Component {
  constructor(props) {
    super(props);
    this.Input_Description1 = React.createRef();
    this.Input_Description2 = React.createRef();
    this.Input_Description3 = React.createRef();
    this.Input_Description4 = React.createRef();
    this.Input_Description5 = React.createRef();
  }
  state = {
    id: this.props.word.id,
    Language1: this.props.word.Language1,
    Language2: this.props.word.Language2,
    Language3: this.props.word.Language3,
    Language4: this.props.word.Language4,
    Language5: this.props.word.Language5,
    Description1: this.props.word.Description1,
    Description2: this.props.word.Description2,
    Description3: this.props.word.Description3,
    Description4: this.props.word.Description4,
    Description5: this.props.word.Description5,
    set: this.props.word.set,
    sets: this.props.sets,

    Language1_Open: false,
    Language2_Open: false,
    Language3_Open: false,
    Language4_Open: false,
    Language5_Open: false,
    Language1_Description_Open: false,
    Language2_Description_Open: false,
    Language3_Description_Open: false,
    Language4_Description_Open: false,
    Language5_Description_Open: false,
    // id: '',
    // Language1: '',
    // Language2: '',
    // Language3: '',
    // Language4: '',
    // Language5: '',
    // Description1: '',
    // Description2: '',
    // Description3: '',
    // Description4: '',
    // Description5: '',
    // set: '',
    // sets: []
    Language_Scrap: "",
    Text_Scrap: "",
    Scrap_All: [],
    Scrap_Short: [],
  };

  componentWillMount() {
    if (this.state.Language1 == undefined) {
      this.setState({
        Language1: "",
      });
    }
    if (this.state.Language2 == undefined) {
      this.setState({
        Language2: "",
      });
    }
    if (this.state.Language3 == undefined) {
      this.setState({
        Language3: "",
      });
    }
    if (this.state.Language4 == undefined) {
      this.setState({
        Language4: "",
      });
    }
    if (this.state.Language5 == undefined) {
      this.setState({
        Language4: "",
      });
    }
    if (this.state.Description1 == undefined) {
      this.setState({
        Description1: "",
      });
    }
    if (this.state.Description2 == undefined) {
      this.setState({
        Description2: "",
      });
    }
    if (this.state.Description3 == undefined) {
      this.setState({
        Description3: "",
      });
    }
    if (this.state.Description4 == undefined) {
      this.setState({
        Description4: "",
      });
    }
    if (this.state.Description5 == undefined) {
      this.setState({
        Description5: "",
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleOpenMenu = (name, event) => {
    this.setState({
      [name]: event.currentTarget,
    });
  };
  handleCloseMenu = (name) => {
    this.setState({
      [name]: false,
    });
  };

  clearField = (name) => {
    this.setState({
      [name]: "",
    });
  };
  clearAllLanguageField = (name1, name2, name3, name4) => {
    this.setState({
      [name1]: "",
      [name2]: "",
      [name3]: "",
      [name4]: "",
    });
  };

  gotoEnd_Input_Description1 = (e) => {
    this.handleCloseMenu("Language1_Description_Open");
    setTimeout(() => this.Input_Description1.current.focus(), 100);
  };
  gotoEnd_Input_Description2 = (e) => {
    this.handleCloseMenu("Language2_Description_Open");
    setTimeout(() => this.Input_Description2.current.focus(), 100);
  };
  gotoEnd_Input_Description3 = (e) => {
    this.handleCloseMenu("Language3_Description_Open");
    setTimeout(() => this.Input_Description3.current.focus(), 100);
  };
  gotoEnd_Input_Description4 = (e) => {
    this.handleCloseMenu("Language4_Description_Open");
    setTimeout(() => this.Input_Description4.current.focus(), 100);
  };
  gotoEnd_Input_Description5 = (e) => {
    this.handleCloseMenu("Language5_Description_Open");
    setTimeout(() => this.Input_Description5.current.focus(), 100);
  };

  handleClone = (e) => {
    // e.preventDefault();
    // console.log(this.state);
    let temp = this.state;
    delete temp.sets;
    // delete this.state.Language_Scrap;
    // delete this.state.Text_Scrap;
    // delete this.state.Scrap_Short;
    // delete this.state.Scrap_Description;
    //delete temp.Scrap_All;
    delete temp.Language1_Open;
    delete temp.Language2_Open;
    delete temp.Language3_Open;
    delete temp.Language4_Open;
    delete temp.Language5_Open;
    delete temp.Language1_Description_Open;
    delete temp.Language2_Description_Open;
    delete temp.Language3_Description_Open;
    delete temp.Language4_Description_Open;
    delete temp.Language5_Description_Open;
    // delete temp.table;

    //this.setState(this.state);

    this.props.createWord(temp, "word_set");
  };

  handleSubmit = (e) => {
    e.preventDefault();
    // console.log(this.state);
    delete this.state.sets;
    this.setState(this.state);
    this.props.updateWord(this.state, this.props.collection_name);
    this.props.editWord(this.state);
    this.props.handleClose();

    //   this.props.history.push('/wordcard');
  };

  handleChangeSelect = (event) => {
    console.log(event);
    this.setState({
      set: event.target.value,
    });
  };
  //   componentWillReceiveProps(nextProps) {
  // alert(nextProps.location.state.id);
  //         this.setState({ id: nextProps.location.state.id,
  //             Language1: nextProps.location.state.Language1});

  //       }
  // componentDidMount() {
  //     alert("mount");
  //     this.setState({ id: this.props.location.state.id,
  //         Language1: this.props.location.state.Language1});
  //     console.log(this.props);
  //   }
  //   componentWillReceiveProps(){
  //  //   console.log(this.props.word);
  //     this.setState({
  //       id: this.props.word.id,
  //       Language1: this.props.word.Language1,
  //       Language2: this.props.word.Language2,
  //       Language3: this.props.word.Language3,
  //       Language4: this.props.word.Language4,
  //       Language5: this.props.word.Language5,
  //       Description1: this.props.word.Description1,
  //       Description2: this.props.word.Description2,
  //       Description3: this.props.word.Description3,
  //       Description4: this.props.word.Description4,
  //       Description5: this.props.word.Description5,
  //       set: this.props.word.set,
  //       sets: this.props.sets
  //     });
  //   }

  componentDidMount() {
    if (this.state.Language4 == undefined) {
      //   alert("asas");
      this.setState({
        Language4: "",
      });
    }
    if (this.state.Language5 == undefined) {
      this.setState({
        Language5: "",
      });
    }
    if (this.state.Description5 == undefined) {
      this.setState({
        Description5: "",
      });
    }
    if (this.state.Description4 == undefined) {
      this.setState({
        Description4: "",
      });
    }
    if (this.state.Description3 == undefined) {
      this.setState({
        Description3: "",
      });
    }
  }

  ScrapGoogleAPI = (translation_text, language, type) => {
    // alert(translation_text);
    if (type != "Description") {
      if (language == "es") {
        this.setState({
          Language1: translation_text,
        });
      } else if (language == "de") {
        this.setState({
          Language2: translation_text,
        });
      } else if (language == "en") {
        this.setState({
          Language3: translation_text,
        });
      } else if (language == "fr") {
        this.setState({
          Language4: translation_text,
        });
      } else if (language == "it") {
        this.setState({
          Language5: translation_text,
        });
      }
    } else {
      if (language == "es") {
        this.setState({
          Description1: translation_text,
        });
      } else if (language == "de") {
        this.setState({
          Description2: translation_text,
        });
      } else if (language == "en") {
        this.setState({
          Description3: translation_text,
        });
      } else if (language == "fr") {
        this.setState({
          Description4: translation_text,
        });
      } else if (language == "it") {
        this.setState({
          Description5: translation_text,
        });
      }
    }
  };

  handleScrapEnglishAll = (list, language, short) => {
    this.setState({
      Scrap_All: list,
      Scrap_Short: short,
    });
    if (language == "Spanish") {
      if (this.state.Language1 == undefined || this.state.Language1 == "")
        this.setState({
          Language1: short[0],
        });
    } else if (language == "German") {
      if (this.state.Language2 == undefined || this.state.Language2 == "")
        this.setState({
          Language2: short[0],
        });
    } else if (language == "French") {
      if (this.state.Language4 == undefined || this.state.Language4 == "")
        this.setState({
          Language4: short[0],
        });
    }
  };
  handleScrap = (list, language, short) => {
    Scrap_Button_Clicked = language;

    this.setState({
      Scrap_All: list,
      Scrap_Short: short,
    });
    document.getElementById("scrap-results-dialog").click();
  };

  handleScrapFiltered = (list, lang, list_short) => {
    let name;
    let name_short;
    if (Scrap_Button_Clicked == "Spanish") {
      name = "Description1";
      name_short = "Language3";
    }
    if (Scrap_Button_Clicked == "German") {
      name = "Description2";
      name_short = "Language3";
    }
    if (Scrap_Button_Clicked == "French") {
      name = "Description4";
      name_short = "Language3";
    }
    //if(Scrap_Button_Clicked=="English"){name="Description1"; name_short="Language1";alert("english")}
    if (Scrap_Button_Clicked == "English") {
      name = "Description4";
      name_short = "Language4";
    }

    let text_short = "";
    for (var i = 1; i < list_short.length; i++) {
      text_short += list_short[i] + ". ";
    }

    let text_english = "";
    let text_other = "";
    for (var i = 1; i < list.length; i++) {
      if (Scrap_Button_Clicked != "English") {
        if (i % 2 === 0) {
          text_english += list[i] + ". ";
        } else {
          text_other += list[i] + ". ";
        }
      } else {
        if (i % 2 === 0) {
          text_other += list[i] + ". ";
          // text_english += list[i] + ". ";
        } else {
          text_english += list[i] + ". ";
          // text_other += list[i] + ". ";
        }
      }
    }

    this.setState({
      [name_short]: text_short,
      [name]: text_other,
      Description3: text_english,
    });
  };

  render() {
    return (
      <div className="container424">
        <form className="white" onSubmit={this.handleSubmit} autocomplete="off">
          {/* <h5 className="grey-text text-darken-3">Editar una nueva oración</h5> */}

          <DialogScrapResult
            handleScrapFiltered={this.handleScrapFiltered}
            description={this.state.Scrap_All}
            short={this.state.Scrap_Short}
          ></DialogScrapResult>

          <TextField
            fullWidth
            id="id"
            label="id"
            className="id"
            value={this.state.id}
            onChange={this.handleChange}
            margin="dense"
          />

          <br></br>

          <div className="display-flex">
            <TextField
              fullWidth
              small
              id="Language1"
              label="Spanish"
              className="Language1"
              value={this.state.Language1}
              onChange={this.handleChange}
              margin="dense"
            />
            <div>
              <IconButton
                aria-haspopup="true"
                onClick={(event) =>
                  this.handleOpenMenu("Language1_Open", event)
                }
                // onClick={this.handleLanguage1_Open}
              >
                <IconArrow></IconArrow>
              </IconButton>
              <Menu
                anchorEl={this.state.Language1_Open}
                keepMounted
                open={this.state.Language1_Open}
                onClose={() => this.handleCloseMenu("Language1_Open")}
              >
                <MenuItem>
                  {" "}
                  <GoogleTranslateAPI
                    ScrapGoogleAPI={this.ScrapGoogleAPI}
                    handleScrap={this.handleScrap}
                    SearchedWord={this.state.Language1}
                    Language={"es"}
                    type={"Language"}
                    Spanish={this.state.Language1}
                    German={this.state.Language2}
                    English={this.state.Language3}
                    French={this.state.Language4}
                    Italian={this.state.Language5}
                  ></GoogleTranslateAPI>
                </MenuItem>
                <MenuItem>
                  {" "}
                  <NewWordScrapper
                    handleScrap={this.handleScrap}
                    SearchedWord={this.state.Language1}
                    Language={"Spanish"}
                  ></NewWordScrapper>
                </MenuItem>
                <MenuItem>
                  <IconButton
                    onClick={() =>
                      this.clearAllLanguageField(
                        "Language2",
                        "Language3",
                        "Language4",
                        "Language5"
                      )
                    }
                  >
                    <IconDeleteAll></IconDeleteAll>
                  </IconButton>{" "}
                </MenuItem>
                <MenuItem>
                  {" "}
                  <IconButton onClick={() => this.clearField("Language1")}>
                    <IconCancel></IconCancel>
                  </IconButton>{" "}
                </MenuItem>
              </Menu>
            </div>
          </div>

          <div className="display-flex">
            <TextField
              fullWidth
              small
              id="Language2"
              label="Deutusch"
              className="Language2"
              value={this.state.Language2}
              onChange={this.handleChange}
              margin="dense"
            />

            <IconButton
              aria-haspopup="true"
              onClick={(event) => this.handleOpenMenu("Language2_Open", event)}
            >
              <IconArrow></IconArrow>
            </IconButton>
            <Menu
              anchorEl={this.state.Language2_Open}
              keepMounted
              open={Boolean(this.state.Language2_Open)}
              onClose={() => this.handleCloseMenu("Language2_Open")}
            >
              <MenuItem>
                {" "}
                <GoogleTranslateAPI
                  ScrapGoogleAPI={this.ScrapGoogleAPI}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Language2}
                  Language={"de"}
                  type={"Language"}
                  Spanish={this.state.Language1}
                  German={this.state.Language2}
                  English={this.state.Language3}
                  French={this.state.Language4}
                  Italian={this.state.Language5}
                ></GoogleTranslateAPI>
              </MenuItem>
              <MenuItem>
                <NewWordScrapper
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Language2}
                  Language={"German"}
                ></NewWordScrapper>
              </MenuItem>
              <MenuItem>
                <IconButton
                  onClick={() =>
                    this.clearAllLanguageField(
                      "Language1",
                      "Language3",
                      "Language4",
                      "Language5"
                    )
                  }
                >
                  <IconDeleteAll></IconDeleteAll>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={() => this.clearField("Language2")}>
                  <IconCancel></IconCancel>
                </IconButton>{" "}
              </MenuItem>
            </Menu>
          </div>

          <div className="display-flex">
            <TextField
              fullWidth
              id="Language3"
              label="English"
              className="Language3"
              value={this.state.Language3}
              onChange={this.handleChange}
              margin="dense"
            />

            <IconButton
              aria-haspopup="true"
              onClick={(event) => this.handleOpenMenu("Language3_Open", event)}
            >
              <IconArrow></IconArrow>
            </IconButton>
            <Menu
              anchorEl={this.state.Language3_Open}
              keepMounted
              open={Boolean(this.state.Language3_Open)}
              onClose={() => this.handleCloseMenu("Language3_Open")}
            >
              <MenuItem>
                <GoogleTranslateAPI
                  ScrapGoogleAPI={this.ScrapGoogleAPI}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Language3}
                  Language={"en"}
                  type={"Language"}
                  Spanish={this.state.Language1}
                  German={this.state.Language2}
                  English={this.state.Language3}
                  French={this.state.Language4}
                  Italian={this.state.Language5}
                ></GoogleTranslateAPI>
              </MenuItem>
              <MenuItem>
                <NewWordScrapperAll
                  handleScrapEnglishAll={this.handleScrapEnglishAll}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Language3}
                  Language={"English"}
                ></NewWordScrapperAll>
              </MenuItem>
              <MenuItem>
                {/* <GoogleScrapper handleScrap={this.handleScrap} SearchedWord={this.state.Language3} Language={"English"}></GoogleScrapper> */}
                <NewWordScrapper
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Language3}
                  Language={"English"}
                ></NewWordScrapper>
              </MenuItem>
              <MenuItem>
                <IconButton
                  onClick={() =>
                    this.clearAllLanguageField(
                      "Language2",
                      "Language1",
                      "Language4",
                      "Language5"
                    )
                  }
                >
                  <IconDeleteAll></IconDeleteAll>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={() => this.clearField("Language3")}>
                  <IconCancel></IconCancel>
                </IconButton>{" "}
              </MenuItem>
            </Menu>
          </div>
          <div className="display-flex">
            <TextField
              fullWidth
              id="Language4"
              label="French"
              className="Language4"
              value={this.state.Language4}
              onChange={this.handleChange}
              margin="dense"
            />

            <IconButton
              aria-haspopup="true"
              onClick={(event) => this.handleOpenMenu("Language4_Open", event)}
            >
              <IconArrow></IconArrow>
            </IconButton>
            <Menu
              anchorEl={this.state.Language4_Open}
              keepMounted
              open={Boolean(this.state.Language4_Open)}
              onClose={() => this.handleCloseMenu("Language4_Open")}
            >
              <MenuItem>
                <GoogleTranslateAPI
                  ScrapGoogleAPI={this.ScrapGoogleAPI}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Language4}
                  Language={"fr"}
                  type={"Language"}
                  Spanish={this.state.Language1}
                  German={this.state.Language2}
                  English={this.state.Language3}
                  French={this.state.Language4}
                  Italian={this.state.Language5}
                ></GoogleTranslateAPI>
              </MenuItem>

              <MenuItem>
                <NewWordScrapper
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Language4}
                  Language={"French"}
                ></NewWordScrapper>
              </MenuItem>
              <MenuItem>
                <IconButton
                  onClick={() =>
                    this.clearAllLanguageField(
                      "Language2",
                      "Language3",
                      "Language1",
                      "Language5"
                    )
                  }
                >
                  <IconDeleteAll></IconDeleteAll>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={() => this.clearField("Language4")}>
                  <IconCancel></IconCancel>
                </IconButton>{" "}
              </MenuItem>
            </Menu>
          </div>
          <div className="display-flex">
            <TextField
              fullWidth
              id="Language5"
              label="Italian"
              className="Language5"
              value={this.state.Language5}
              onChange={this.handleChange}
              margin="dense"
            />

            <IconButton
              aria-haspopup="true"
              onClick={(event) => this.handleOpenMenu("Language5_Open", event)}
            >
              <IconArrow></IconArrow>
            </IconButton>
            <Menu
              anchorEl={this.state.Language5_Open}
              keepMounted
              open={Boolean(this.state.Language5_Open)}
              onClose={() => this.handleCloseMenu("Language5_Open")}
            >
              <MenuItem>
                <GoogleTranslateAPI
                  ScrapGoogleAPI={this.ScrapGoogleAPI}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Language5}
                  Language={"it"}
                  type={"Language"}
                  Spanish={this.state.Language1}
                  German={this.state.Language2}
                  English={this.state.Language3}
                  French={this.state.Language4}
                  Italian={this.state.Language5}
                ></GoogleTranslateAPI>
              </MenuItem>
              <MenuItem>
                <IconButton
                  onClick={() =>
                    this.clearAllLanguageField(
                      "Language2",
                      "Language3",
                      "Language4",
                      "Language1"
                    )
                  }
                >
                  <IconDeleteAll></IconDeleteAll>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={() => this.clearField("Language5")}>
                  <IconCancel></IconCancel>
                </IconButton>{" "}
              </MenuItem>
            </Menu>
          </div>
          {/* DESCRIPTION */}
          {/* DESCRIPTION */}
          {/* DESCRIPTION */}
          <div className="display-flex">
            <TextField
              inputRef={this.Input_Description1}
              fullWidth
              id="Description1"
              label="Spanish Description1"
              className="Description1"
              value={this.state.Description1}
              onChange={this.handleChange}
              margin="dense"
            />

            <IconButton
              aria-haspopup="true"
              onClick={(event) =>
                this.handleOpenMenu("Language1_Description_Open", event)
              }
            >
              <IconArrow></IconArrow>
            </IconButton>
            <Menu
              anchorEl={this.state.Language1_Description_Open}
              keepMounted
              open={Boolean(this.state.Language1_Description_Open)}
              onClose={() => this.handleCloseMenu("Language1_Description_Open")}
            >
              <MenuItem>
                <GoogleTranslateAPI
                  ScrapGoogleAPI={this.ScrapGoogleAPI}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Description1}
                  Language={"es"}
                  type={"Description"}
                  Spanish={this.state.Description1}
                  German={this.state.Description2}
                  English={this.state.Description3}
                  French={this.state.Description4}
                  Italian={this.state.Description5}
                ></GoogleTranslateAPI>
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={this.gotoEnd_Input_Description1}>
                  <IconToRight></IconToRight>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                <IconButton
                  onClick={() =>
                    this.clearAllLanguageField(
                      "Description2",
                      "Description3",
                      "Description4",
                      "Description5"
                    )
                  }
                >
                  <IconDeleteAll></IconDeleteAll>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={() => this.clearField("Description1")}>
                  <IconCancel></IconCancel>
                </IconButton>{" "}
              </MenuItem>
            </Menu>
          </div>

          <div className="display-flex">
            <TextField
              inputRef={this.Input_Description2}
              fullWidth
              id="Description2"
              label="Deutsch Description2"
              className="Description2"
              value={this.state.Description2}
              onChange={this.handleChange}
              margin="dense"
            />

            <IconButton
              aria-haspopup="true"
              onClick={(event) =>
                this.handleOpenMenu("Language2_Description_Open", event)
              }
            >
              <IconArrow></IconArrow>
            </IconButton>
            <Menu
              anchorEl={this.state.Language2_Description_Open}
              keepMounted
              open={Boolean(this.state.Language2_Description_Open)}
              onClose={() => this.handleCloseMenu("Language2_Description_Open")}
            >
              <MenuItem>
                <GoogleTranslateAPI
                  ScrapGoogleAPI={this.ScrapGoogleAPI}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Description2}
                  Language={"de"}
                  type={"Description"}
                  Spanish={this.state.Description1}
                  German={this.state.Description2}
                  English={this.state.Description3}
                  French={this.state.Description4}
                  Italian={this.state.Description5}
                ></GoogleTranslateAPI>
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={this.gotoEnd_Input_Description2}>
                  <IconToRight></IconToRight>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                <IconButton
                  onClick={() =>
                    this.clearAllLanguageField(
                      "Description1",
                      "Description3",
                      "Description4",
                      "Description5"
                    )
                  }
                >
                  <IconDeleteAll></IconDeleteAll>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={() => this.clearField("Description2")}>
                  <IconCancel></IconCancel>
                </IconButton>{" "}
              </MenuItem>
            </Menu>
          </div>

          <div className="display-flex">
            <TextField
              inputRef={this.Input_Description3}
              fullWidth
              id="Description3"
              label="English Description3"
              className="Description3"
              value={this.state.Description3}
              onChange={this.handleChange}
              margin="dense"
            />

            <IconButton
              aria-haspopup="true"
              onClick={(event) =>
                this.handleOpenMenu("Language3_Description_Open", event)
              }
            >
              <IconArrow></IconArrow>
            </IconButton>
            <Menu
              anchorEl={this.state.Language3_Description_Open}
              keepMounted
              open={Boolean(this.state.Language3_Description_Open)}
              onClose={() => this.handleCloseMenu("Language3_Description_Open")}
            >
              <MenuItem>
                <GoogleTranslateAPI
                  ScrapGoogleAPI={this.ScrapGoogleAPI}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Description3}
                  Language={"en"}
                  type={"Description"}
                  Spanish={this.state.Description1}
                  German={this.state.Description2}
                  English={this.state.Description3}
                  French={this.state.Description4}
                  Italian={this.state.Description5}
                ></GoogleTranslateAPI>
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={this.gotoEnd_Input_Description3}>
                  <IconToRight></IconToRight>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                <IconButton
                  onClick={() =>
                    this.clearAllLanguageField(
                      "Description2",
                      "Description1",
                      "Description4",
                      "Description5"
                    )
                  }
                >
                  <IconDeleteAll></IconDeleteAll>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={() => this.clearField("Description3")}>
                  <IconCancel></IconCancel>
                </IconButton>{" "}
              </MenuItem>
            </Menu>
          </div>

          <div className="display-flex">
            <TextField
              inputRef={this.Input_Description4}
              fullWidth
              id="Description4"
              label="French Description4"
              className="Description4"
              value={this.state.Description4}
              onChange={this.handleChange}
              margin="dense"
            />

            <IconButton
              aria-haspopup="true"
              onClick={(event) =>
                this.handleOpenMenu("Language4_Description_Open", event)
              }
            >
              <IconArrow></IconArrow>
            </IconButton>
            <Menu
              anchorEl={this.state.Language4_Description_Open}
              keepMounted
              open={Boolean(this.state.Language4_Description_Open)}
              onClose={() => this.handleCloseMenu("Language4_Description_Open")}
            >
              <MenuItem>
                <GoogleTranslateAPI
                  ScrapGoogleAPI={this.ScrapGoogleAPI}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Description4}
                  Language={"fr"}
                  type={"Description"}
                  Spanish={this.state.Description1}
                  German={this.state.Description2}
                  English={this.state.Description3}
                  French={this.state.Description4}
                  Italian={this.state.Description5}
                ></GoogleTranslateAPI>
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={this.gotoEnd_Input_Description4}>
                  <IconToRight></IconToRight>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                <IconButton
                  onClick={() =>
                    this.clearAllLanguageField(
                      "Description2",
                      "Description3",
                      "Description1",
                      "Description5"
                    )
                  }
                >
                  <IconDeleteAll></IconDeleteAll>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={() => this.clearField("Description4")}>
                  <IconCancel></IconCancel>
                </IconButton>{" "}
              </MenuItem>
            </Menu>
          </div>
          <div className="display-flex">
            <TextField
              inputRef={this.Input_Description5}
              fullWidth
              id="Description5"
              label="Italian Description5"
              className="Description5"
              value={this.state.Description5}
              onChange={this.handleChange}
              margin="dense"
            />

            <IconButton
              aria-haspopup="true"
              onClick={(event) =>
                this.handleOpenMenu("Language5_Description_Open", event)
              }
            >
              <IconArrow></IconArrow>
            </IconButton>
            <Menu
              anchorEl={this.state.Language5_Description_Open}
              keepMounted
              open={Boolean(this.state.Language5_Description_Open)}
              onClose={() => this.handleCloseMenu("Language5_Description_Open")}
            >
              <MenuItem>
                <GoogleTranslateAPI
                  ScrapGoogleAPI={this.ScrapGoogleAPI}
                  handleScrap={this.handleScrap}
                  SearchedWord={this.state.Description5}
                  Language={"it"}
                  type={"Description"}
                  Spanish={this.state.Description1}
                  German={this.state.Description2}
                  English={this.state.Description3}
                  French={this.state.Description4}
                  Italian={this.state.Description5}
                ></GoogleTranslateAPI>
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={this.gotoEnd_Input_Description5}>
                  <IconToRight></IconToRight>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                <IconButton
                  onClick={() =>
                    this.clearAllLanguageField(
                      "Description2",
                      "Description3",
                      "Description4",
                      "Description1"
                    )
                  }
                >
                  <IconDeleteAll></IconDeleteAll>
                </IconButton>{" "}
              </MenuItem>
              <MenuItem>
                {" "}
                <IconButton onClick={() => this.clearField("Description5")}>
                  <IconCancel></IconCancel>
                </IconButton>{" "}
              </MenuItem>
            </Menu>
          </div>

          <br></br>

          <br></br>
          <FormControl>
            <InputLabel htmlFor="name-simple">Set</InputLabel>
            <Select
              value={this.state.set}
              onChange={this.handleChangeSelect}
              inputProps={{
                name: "name",
                id: "name-simple",
              }}
            >
              {typeof this.state.sets != "undefined" &&
                this.state.sets.map((se) => (
                  <MenuItem value={se.name}>{se.name}</MenuItem>
                ))}
            </Select>
          </FormControl>

          <br></br>
          <br></br>
          <Button
            onClick={() => this.handleClone()}
            variant="contained"
            color="secondary"
          >
            Clone
          </Button>

          <Button
            type="submit"
            value="Submit"
            variant="contained"
            color="secondary"
            className="left-margin-10px"
          >
            Update
          </Button>

          {/* <div className="input-field">
                        <button className="btn pink lighten-1">Create</button>
                    </div> */}
        </form>
        <br></br>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateWord: (word, table_name) => dispatch(updateWord(word, table_name)),
    createWord: (word, table_name) => dispatch(createWord(word, table_name)),
  };
};

export default connect(null, mapDispatchToProps)(EditExistingWordDialog);

//rafc
//rce
